"use client";
import * as stylex from "@stylexjs/stylex";
import * as React from "react";
import * as ReactDOM from "react-dom";
import { Dialog } from "./internal";
export function Commands(props) {
    const { open: _open, onClose: _onClose } = props;
    const [state, setState] = React.useState({
        /**
     * If the dialog is visible (even during the closing transition), this
     * object contains both the container element (a div appended to the end of
     * the body) and the React Portal (that is returned by this component).
     */ dialog: null
    });
    function open() {
        setState({
            dialog: (()=>{
                if (!state.dialog) {
                    const containerElement = document.createElement("div");
                    document.body.appendChild(containerElement);
                    const reactPortal = ReactDOM.createPortal(<div className="xixxii4 x10a8y8t x78zum5 xoz0ns6 x1cy8zhl xl56j7k x1tv4xqk x1p7i66b xdvd4st x1746jcd x1j61zf2 x1wqqpke" onClick={(ev)=>{
                        if (ev.target === ev.currentTarget) {
                            _onClose();
                        }
                    }}>
              <Dialog open onClose={_onClose}/>
            </div>, containerElement);
                    return {
                        containerElement,
                        reactPortal
                    };
                } else {
                    return {
                        containerElement: state.dialog.containerElement,
                        reactPortal: ReactDOM.createPortal(<div className="xixxii4 x10a8y8t x78zum5 xoz0ns6 x1cy8zhl xl56j7k x1tv4xqk x1p7i66b xdvd4st x1746jcd x1j61zf2 x1wqqpke" onClick={(ev)=>{
                            if (ev.target === ev.currentTarget) {
                                _onClose();
                            }
                        }}>
                <Dialog open onClose={_onClose}/>
              </div>, state.dialog.containerElement)
                    };
                }
            })()
        });
    }
    function close() {
        setState({
            dialog: (()=>{
                if (state.dialog) {
                    return {
                        containerElement: state.dialog.containerElement,
                        reactPortal: ReactDOM.createPortal(<div className="xixxii4 x10a8y8t x78zum5 xoz0ns6 x1cy8zhl xl56j7k x1tv4xqk x1p7i66b xdvd4st x1746jcd x1j61zf2 x1wqqpke">
                <Dialog onDispose={()=>{
                            setState({
                                dialog: (()=>{
                                    if (!_open && state.dialog) {
                                        document.body.removeChild(state.dialog.containerElement);
                                        return null;
                                    } else {
                                        return state.dialog;
                                    }
                                })()
                            });
                        }}/>
              </div>, state.dialog.containerElement)
                    };
                } else {
                    return state.dialog;
                }
            })()
        });
    }
    /*
   * Crude body scroll lock when the dialog is open.
   */ // biome-ignore lint/correctness/useExhaustiveDependencies: TODO
    React.useEffect(()=>{
        if (_open) {
            document.body.style.overflow = "hidden";
            open();
            return ()=>{
                document.body.style.overflow = "";
            };
        } else {
            close();
        }
    }, [
        _open
    ]);
    return state.dialog?.reactPortal ?? null;
}
